import React from 'react'
import { Box, BoxProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export interface CardProps extends BoxProps {
  interactive?: boolean
  padding?: 'none' | 'sm' | 'md' | 'lg'
}

const padMap = {
  none: '0',
  sm: 'var(--ds-space-3)',
  md: 'var(--ds-space-4)',
  lg: 'var(--ds-space-5)',
}

const Root = styled(Box, {
  shouldForwardProp: (p) => p !== 'interactive' && p !== 'pad',
})<{ interactive?: boolean; pad: keyof typeof padMap }>(({ interactive, pad }) => ({
  backgroundColor: 'var(--ds-surface)',
  borderRadius: 'var(--ds-radius-lg)',
  padding: padMap[pad],
  transition: `transform var(--ds-duration-normal) var(--ds-ease), box-shadow var(--ds-duration-normal) var(--ds-ease)`,
  ...(interactive && {
    cursor: 'pointer',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: 'var(--ds-shadow-soft)',
    },
  }),
}))

/** Non-photo surface card. For albums use AlbumCard (photo cover). */
export const Card = React.forwardRef<HTMLDivElement, CardProps>(function Card(
  { interactive, padding = 'md', children, ...rest },
  ref,
) {
  return (
    <Root ref={ref} interactive={interactive} pad={padding} {...rest}>
      {children}
    </Root>
  )
})
